var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Repeater',{attrs:{"value":_vm.value || [],"control":{
    options: {
      repeaterOptions: {
        defaultNewValue: {
          name: '',
          template: ''
        },
        titleTemplate: 'HTML Attribute',
        buttonName: 'Add new HTML attribute'
      }
    }
  }},on:{"input":function($event){return _vm.updateAttributes($event)}},scopedSlots:_vm._u([{key:"default",fn:function({ index: repeaterIndex, value }){return [_c('b',[_vm._v("Attribute Name")]),_c('v-text-field',{attrs:{"value":value.name,"rules":[_vm.htmlAttributeNameRule]},on:{"input":function($event){return _vm.updateName(repeaterIndex, $event)}}}),_c('b',[_vm._v("Attribute Value")]),('template' in value)?_c('CodeInput',{attrs:{"value":value.template,"language":"html"},on:{"input":function($event){return _vm.updateTemplateValue(repeaterIndex, $event)}}}):('propertyPath' in value)?_c('v-text-field',{attrs:{"value":value.template},on:{"input":function($event){return _vm.updatePropertyPathValue(repeaterIndex, $event)}}}):('rawValue' in value)?_c('v-text-field',{attrs:{"value":value.template},on:{"input":function($event){return _vm.updateRawValue(repeaterIndex, $event)}}}):_vm._e()]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }